import { getNoteContentAsPlainText } from './getNoteContentAsPlainText.mjs'

export function noteContainsString(note, q) {
  if (!note || !note.yDoc) return false
  let matchesTag = note.tagArray.containsString(q)
  if (matchesTag) {
    return true
  }
  const content = getNoteContentAsPlainText(note)
  return (
    content.toLowerCase().includes(q.toLowerCase()) ||
    note.title.toLowerCase().includes(q.toLowerCase())
  )
}
